/*!
 * MV motion plus v1.0, 25 Oct 2026. Loaded on every page by snippets/mv-motion-plus.liquid (switch: Footer >
 * MV fix first > "Motion plus"). Adds to assets/mv-motion.js and mv-landing-motion.js: card light sweeps, sale
 * badge pop and glint, drawn was-price strikes, sale price flash, tap press, fly-to-cart, collection header light,
 * chip shine, count fade, Add to cart shine and glow, option and bundle tier pops, icon pops, count-up numbers and
 * a reading line on landing pages. Hand-built sections keep their own motion. Off for reduced motion.
 */
(function () {
  'use strict';

  var w = window, d = document, h = d.documentElement;
  if (w.MVMotionPlus) return;
  var cfg = w.MVMotionPlusConfig || {};
  var rm = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  if (cfg.off || (rm && rm.matches) || !('IntersectionObserver' in w)) return;
  var api = (w.MVMotionPlus = { version: '1.0.0' });
  var editor = !!(w.Shopify && w.Shopify.designMode);

  var SKIP = '.mv-hh-section,.mv-ht-section,.mv-cf-section,.mv-bt-section,.mv-rt-section,[id*="mvtrade"],' +
    '.shopify-section-group-header-group,.shopify-section-group-footer-group,cart-drawer,cart-notification,' +
    '.quick-add-modal,product-modal,.menu-drawer,.predictive-search,.shopify-app-block,[class*="jdgm"],' +
    '[class*="mv-benefit"],[data-mv-skip]';
  var CARD = '.product-card-wrapper,.collection-card-wrapper,.article-card-wrapper';
  var CTA = 'product-info button[name="add"],.product__info-container button[name="add"],sticky-atc button[name="add"],' +
    '.sticky-atc button[name="add"],.mv-pl-cta__btn' + (cfg.landing ? ',#MainContent .button--primary' : '');
  var BADGE = '.price--on-sale .price__badge-sale,.price--on-sale .price__badge-custom';
  var GROUP = '.icon-with-text,.icons-with-text__icon-item,.product__text-container,.icon-bar-card';
  var ICON = '.icon-with-text__item>.material-icon,.icon-with-text__item>img,.icons-with-text__icon__icon,' +
    '.product__text>.material-icon,.product__text>img,.icon-bar-card__icon>.material-icon,.icon-bar-card__icon>img';
  var NUMS = 'h1,h2,h3,h4,.h0,.h1,.h2,.h3,.h4,[class*="number"],[class*="counter"],[class*="stat"]';
  var NOCOUNT = '.price,form,.product__info-container,.card-wrapper,.mv-split,.sticky-atc,[class*="inventory"],' +
    '[class*="stock"],[class*="rating"],[class*="review"]';
  var NUM = /^(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?(\s?[+%kKxX]|\s?\/\s?\d+)?$/;
  var OWN = /(^|\s)(mvp-sheen|mvp-shine|mvp-fly|mvp-progress|mvx-sheen|mv-w|mv-btn-progress)(\s|$)/;

  function skipped(el) {
    return !!(el.closest && el.closest(SKIP));
  }

  function each(root, sel, fn) {
    if (!root || !root.querySelectorAll) return;
    if (root.nodeType === 1 && root.matches(sel)) fn(root);
    var list = root.querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) fn(list[i]);
  }

  function onScreen(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < w.innerHeight && (r.width > 0 || r.height > 0);
  }

  function span(cls) {
    var s = d.createElement('span');
    s.className = cls;
    s.setAttribute('aria-hidden', 'true');
    return s;
  }

  /* Adds a class for a while, restarting its animation if it is already there. */
  function flag(el, cls, life) {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
    clearTimeout(el['mvpT' + cls]);
    el['mvpT' + cls] = setTimeout(function () {
      el.classList.remove(cls);
    }, life);
  }

  function byPos(a, b) {
    return Math.round(a.boundingClientRect.top - b.boundingClientRect.top) || a.boundingClientRect.left - b.boundingClientRect.left;
  }

  /* Loops (glint, glow, header light) only run while on screen. */
  var liveIO = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) entries[i].target.classList.toggle('mvp-live', entries[i].isIntersecting);
  });

  /* Cards arrive in reading order, in step with the theme's own rise-in. */
  var cardN = 0;
  var cardIO = new IntersectionObserver(
    function (entries) {
      var batch = [];
      for (var i = 0; i < entries.length; i++) {
        var t = entries[i].target;
        t.classList.toggle('mvp-live', entries[i].isIntersecting);
        if (entries[i].isIntersecting && !t.classList.contains('mvp-go')) batch.push(entries[i]);
      }
      batch.sort(byPos);
      for (var k = 0; k < batch.length; k++) {
        batch[k].target.style.setProperty('--mvp-d', 380 + Math.min(k, 8) * 70 + 'ms');
        batch[k].target.classList.add('mvp-go');
      }
    },
    { rootMargin: '0px 0px -8% 0px' }
  );

  function card(el) {
    if (el.__mvp) return;
    el.__mvp = true;
    if (skipped(el)) return;
    el.classList.add('mvp-card');
    if (el.querySelector('.price--on-sale:not(.price--sold-out)')) el.classList.add('mvp-sale');
    var media = el.querySelector('.card__media');
    if (media && !media.querySelector(':scope>.mvp-sheen')) media.appendChild(span('mvp-sheen'));
    el.style.setProperty('--mvp-n', cardN++ % 6);
    el.classList.toggle('mvp-armed', !editor && !onScreen(el) && !el.classList.contains('mvp-go'));
    cardIO.observe(el);
  }

  /* Quick add straight to cart (not the options pop-up): the photo flies to the cart icon. */
  function fly(cardEl, btn) {
    var img = cardEl.querySelector('.card__media img');
    if (!img || !img.animate || (rm && rm.matches)) return;
    var a = img.getBoundingClientRect();
    if (!a.width || !a.height) return;
    var icons = d.querySelectorAll('#cart-icon-bubble,.header__icon--cart');
    var to = null;
    for (var i = 0; i < icons.length && !to; i++) {
      var r = icons[i].getBoundingClientRect();
      if (r.width && r.bottom > 0 && r.top < w.innerHeight) to = r;
    }
    var tx = to ? to.left + to.width / 2 : w.innerWidth - 34;
    var ty = to ? to.top + to.height / 2 : 34;
    var size = Math.min(a.width, a.height, 200);
    var x = a.left + a.width / 2;
    var y = a.top + a.height / 2;
    if (y < 0 || y > w.innerHeight) {
      /* Photo scrolled out of view: the flight starts from the button instead. */
      var bb = btn.getBoundingClientRect();
      size = Math.min(size, 90);
      x = bb.left + bb.width / 2;
      y = bb.top + bb.height / 2;
    }
    var c = d.createElement('img');
    c.className = 'mvp-fly';
    c.alt = '';
    c.setAttribute('aria-hidden', 'true');
    c.src = img.currentSrc || img.src;
    c.style.cssText = 'left:' + (x - size / 2) + 'px;top:' + (y - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px';
    d.body.appendChild(c);
    var dx = tx - x, dy = ty - y;
    c.animate(
      [
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + (dx * 0.4).toFixed(1) + 'px,' + (dy * 0.4 - 80).toFixed(1) + 'px) scale(0.6)', opacity: 1, offset: 0.45 },
        { transform: 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px) scale(0.12)', opacity: 0.3 }
      ],
      { duration: 820, easing: 'cubic-bezier(0.5,0,0.3,1)' }
    ).onfinish = function () {
      if (c.parentNode) c.parentNode.removeChild(c);
    };
  }

  /* Collection header: a passing light, and the category chips shine once in turn. */
  function hero(el) {
    if (el.__mvp) return;
    el.__mvp = true;
    el.classList.add('mvp-hero');
    liveIO.observe(el);
    var chips = el.querySelectorAll('.mv-chero__categories a');
    for (var i = 0; i < chips.length; i++) {
      chips[i].classList.add('mvp-chip');
      chips[i].appendChild(span('mvp-shine'));
      chips[i].style.setProperty('--mvp-d', 900 + i * 110 + 'ms');
    }
    requestAnimationFrame(function () {
      for (var j = 0; j < chips.length; j++) chips[j].classList.add('mvp-go');
    });
  }

  function counted(node) {
    var c = node.closest && node.closest('#ProductCount,#ProductCountDesktop');
    if (c) flag(c, 'mvp-count', 700);
  }

  /* Add to cart and other calls to action. */
  function cta(el) {
    if (el.__mvp) return;
    el.__mvp = true;
    if (skipped(el) || el.closest('.card-wrapper') || (el.closest('form') && !el.closest('product-form,form[action*="/cart/add"]'))) return;
    el.classList.add('mvp-cta');
    if (el.closest('sticky-atc,.sticky-atc')) el.classList.add('mvp-quiet');
    if (!el.querySelector(':scope>.mvp-shine')) el.appendChild(span('mvp-shine'));
    liveIO.observe(el);
  }

  /* Every 6 seconds each call to action on screen gets a shine (a light slides across; nothing moves). */
  function sweep() {
    if (d.hidden || (rm && rm.matches)) return;
    var list = d.querySelectorAll('.mvp-cta.mvp-live');
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (b.disabled || b.classList.contains('loading') || b.getAttribute('aria-disabled') === 'true') continue;
      flag(b, 'mvp-sweep', 1300);
    }
  }

  function glint(el) {
    if (el.__mvp) return;
    el.__mvp = true;
    if (skipped(el) || el.closest('.card-wrapper')) return;
    el.classList.add('mvp-glint');
    liveIO.observe(el);
  }

  /* Icon rows: icons pop in one after another as the row arrives. */
  var iconIO = new IntersectionObserver(
    function (entries) {
      var batch = [];
      for (var i = 0; i < entries.length; i++) if (entries[i].isIntersecting) batch.push(entries[i]);
      batch.sort(byPos);
      var n = 0;
      for (var k = 0; k < batch.length; k++) {
        var g = batch[k].target;
        var list = g.querySelectorAll(ICON);
        iconIO.unobserve(g);
        for (var j = 0; j < list.length; j++) list[j].style.setProperty('--mvp-i', Math.min(n++, 8));
        g.classList.add('mvp-go');
      }
    },
    { rootMargin: '0px 0px -8% 0px' }
  );

  function icons(g) {
    if (g.__mvp) return;
    g.__mvp = true;
    if (skipped(g) || !g.querySelector(ICON)) return;
    g.classList.add('mvp-icons');
    g.classList.toggle('mvp-armed', !editor && !onScreen(g) && !g.classList.contains('mvp-go'));
    iconIO.observe(g);
  }

  /* Numbers standing alone in headings and stat blocks count up to their real value. */
  var numIO = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].intersectionRatio < 0.5) continue;
        numIO.unobserve(entries[i].target);
        countUp(entries[i].target);
      }
    },
    { threshold: [0, 0.5] }
  );

  function number(el) {
    if (el.__mvpN) return;
    el.__mvpN = true;
    if (el.children.length || editor || skipped(el) || onScreen(el) || el.closest(NOCOUNT)) return;
    var text = (el.textContent || '').trim();
    var m = NUM.exec(text);
    if (!m) return;
    var value = parseFloat(m[1].replace(/,/g, '') + (m[2] || ''));
    /* Plain whole numbers must be 10 or more (step numbers stay put) and never a year. */
    if (!(value >= 1) || (!m[2] && !m[3] && (value < 10 || /^(19|20)\d\d$/.test(m[1])))) return;
    el.__mvpV = { text: text, value: value, dp: m[2] ? m[2].length - 1 : 0, commas: m[1].indexOf(',') > -1, tail: m[3] || '' };
    numIO.observe(el);
  }

  function countUp(el) {
    var n = el.__mvpV;
    if (!n || (rm && rm.matches)) return;
    var start = null;
    var fmt = function (v) {
      var s = v.toFixed(n.dp);
      if (n.commas) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return s + n.tail;
    };
    var step = function (ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / 1400);
      if (t < 1) {
        el.textContent = fmt(n.value * (1 - Math.pow(1 - t, 3)));
        requestAnimationFrame(step);
      } else {
        el.textContent = n.text;
        el.classList.remove('mvp-counting');
      }
    };
    el.classList.add('mvp-counting');
    el.textContent = fmt(0);
    requestAnimationFrame(step);
  }

  /* Landing pages: a gold line along the top shows how far through the page you are. */
  function readingLine() {
    var main = d.getElementById('MainContent') || d.querySelector('main');
    if (!cfg.landing || !main || d.querySelector('.mvp-progress,.mv-read-progress')) return;
    var line = span('mvp-progress');
    d.body.appendChild(line);
    var queued = false;
    var update = function () {
      queued = false;
      var r = main.getBoundingClientRect();
      var total = r.height - w.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      line.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    };
    var queue = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    };
    w.addEventListener('scroll', queue, { passive: true });
    w.addEventListener('resize', queue);
    update();
  }

  /* Discovery: page load, theme editor reloads and anything added later (infinite scroll, filters). */
  function scan(root) {
    each(root, CARD, card);
    each(root, '.mv-chero', hero);
    each(root, CTA, cta);
    each(root, BADGE, glint);
    each(root, GROUP, icons);
    var main = d.getElementById('MainContent');
    if (main && (root === d || main.contains(root))) each(root === d ? main : root, NUMS, number);
  }

  function watch() {
    var pending = [];
    var queued = false;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var rec = records[i];
        if (rec.target.nodeType === 1) counted(rec.target);
        for (var j = 0; j < rec.addedNodes.length; j++) {
          var n = rec.addedNodes[j];
          if (n.nodeType !== 1 || /^(SCRIPT|STYLE|LINK|META)$/.test(n.tagName) || OWN.test(n.getAttribute('class') || '')) continue;
          pending.push(n);
        }
      }
      if (!pending.length || queued) return;
      queued = true;
      requestAnimationFrame(function () {
        var list = pending;
        pending = [];
        queued = false;
        for (var k = 0; k < list.length; k++) if (list[k].isConnected) scan(list[k]);
      });
    }).observe(d.body, { childList: true, subtree: true });
  }

  function events() {
    d.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.quick-add__submit') : null;
      if (!b || b.disabled || b.classList.contains('loading') || b.closest('modal-opener,a')) return;
      var c = b.closest('.mvp-card');
      if (c) fly(c, b);
    }, true);
    d.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio' || !t.id || !t.closest || skipped(t)) return;
      var label = d.querySelector('label[for="' + (w.CSS && CSS.escape ? CSS.escape(t.id) : t.id) + '"]');
      if (!label) return;
      if (label.classList.contains('quantity-break')) flag(label, 'mvp-tier', 1000);
      else if (t.closest('.product-form__input') && !t.closest('.card-wrapper')) flag(label, 'mvp-pick', 600);
    });
    /* iOS only applies :active (the tap press on cards) when a touch listener exists. */
    d.addEventListener('touchstart', function () {}, { passive: true });
    d.addEventListener('shopify:section:load', function (e) {
      scan(e.target);
    });
  }

  function boot() {
    try {
      h.classList.add('mvp');
      scan(d);
      watch();
      events();
      readingLine();
      setInterval(sweep, 6000);
      /* Safety net: anything still waiting once the page has settled is shown. */
      setTimeout(function () {
        each(d, '.mvp-armed:not(.mvp-go)', function (el) {
          if (onScreen(el)) el.classList.add('mvp-go');
        });
      }, 4000);
      api.ready = true;
    } catch (err) {
      h.classList.remove('mvp');
      if (w.console && console.warn) console.warn('[MV motion plus] switched off:', err);
    }
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot);
  else boot();
})();